import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

// Modules
import user from './modules/user';
import rotator from './modules/rotator';
import cache from './modules/cache';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  state: {
    activePanel: null
  },
  mutations: {
    setPanel(state, panel) {
      state.activePanel = panel;
    }
  },
  modules: {
    user,
    rotator,
    cache
  },
  strict: debug,
  plugins: [
    createPersistedState({
      key: 'radius',
      setState(key, state) {
        // Copy state so we can modify it
        // benchmarked to be the fastest way to deep clone object http://jsben.ch/bWfk9
        var copy = JSON.parse(JSON.stringify(state))

        // Delete keys we don't want persisted
        delete copy['activePanel']
        delete copy.cache
        copy.rotator = { sites: copy.rotator.sites }

        window.localStorage.setItem(key, JSON.stringify(copy))
      }
    })
  ]
});



// WEBPACK FOOTER //
// ./src/store/index.js